import isNumber from "is-number";
import _ from "lodash";
import { observer } from "mobx-react";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import React from "react";
import styled from "styled-components";
import { useStore2 } from "../../../../WSUtils/useStore";
import { concatClassnames } from "../../../../WSUtils/util";
import { getQuestionType, QuestionType } from "../QuestionType";
import { CVEQuestionProps } from "./CVEQuestion";
import { CVETextQuestionStore } from "./CVETextQuestionStore";

export const CVETextQuestion = observer(
  ({ question, hidden }: CVEQuestionProps) => {
    const storeName = `CVEQuestionStore_text_${question.id}`;

    const store = useStore2(
      storeName,
      (dt) =>
        new CVETextQuestionStore({
          name: storeName,
          parentDt: dt,
        })
    );

    const type = getQuestionType(question);

    store._onRender(question);

    return (
      <StyledCVETextQuestion
        className={concatClassnames([
          "cve-text-question",
          type === QuestionType.NUMBER && "cve-numeric-text-question",
        ])}
      >
        {type === QuestionType.NUMBER && (
          <InputText
            type="number"
            value={store.value}
            disabled={hidden}
            onChange={(evt) => {
              if (!isNumber(evt.target.value)) {
                store.onChange("");
                return;
              }

              let val = Number(evt.target.value);

              const lowerLimit = question.options[0].lowerLimit;
              const upperLimit = question.options[0].upperLimit;

              if (
                lowerLimit !== upperLimit &&
                isNumber(lowerLimit) &&
                isNumber(upperLimit)
              ) {
                val = _.clamp(val, lowerLimit, upperLimit);
              }

              store.onChange(val.toString());
            }}
          />
        )}
        {type !== QuestionType.NUMBER && (
          <InputText
            disabled={hidden}
            value={store.value ?? ""}
            onChange={(evt) => {
              store.onChange(evt.target.value);
            }}
          />
        )}
      </StyledCVETextQuestion>
    );
  }
);

export const StyledCVETextQuestion = styled.div`
  &.cve-text-question {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    .cve-save-text-question-button {
      margin-top: 0.25rem;
    }
  }
`;
